/* Bundle / "complete the look" section behaviour (paired with snippets/product-single-bundle.liquid).
   - Live set totals (discount applies only to the checked complementary items; main stays full price).
   - Auto-matches each complementary variant to the main product's selected variant (most shared
     option VALUES wins; falls back to first available). Recomputed when the main variant changes.
   - Under each card title, the chosen variant is shown small ("option name: value") -- as of
     2026-07-24 this now ALSO applies to the main/anchor product's own card (previously only the
     companion cards showed it), per feedback with a screenshot: the anchor card showed only a
     price, with no indication of which option (e.g. plating/size) the customer had actually
     selected above, even though the companion cards already showed this for their own
     auto-matched variant. See mainVariantLabel() / the data-bundle-main-variant-label span in
     product-single-bundle.liquid.
   - Eye button opens a fullscreen gallery lightbox of that product's images.
   - Pencil button (only when the product has real variants) opens a popover whose selectors are
     styled like the storefront (round colour swatches + pill size buttons). Saving overrides the
     variant manually and that card stops auto-matching.
   - Adds the whole set to the cart as separate lines sharing a _bundle_id property. */
(function () {
  function money(cents) {
    var n = cents / 100;
    var hasFrac = Math.round(n * 100) % 100 !== 0;
    return '₪' + n.toLocaleString('he-IL', { minimumFractionDigits: hasFrac ? 2 : 0, maximumFractionDigits: 2 });
  }
  function parseJSON(el) { try { return JSON.parse(el.textContent); } catch (e) { return null; } }
  function mainVariantsOf(root) { var s = root.querySelector('[data-bundle-main-variants]'); return s ? (parseJSON(s) || []) : []; }
  function mainOptionNamesOf(root) { var s = root.querySelector('[data-bundle-main-optionnames]'); return s ? (parseJSON(s) || []) : []; }
  function variantsOf(item) { var s = item.querySelector('[data-bundle-variants]'); return s ? (parseJSON(s) || []) : []; }
  function optionNamesOf(item) { var s = item.querySelector('[data-bundle-optionnames]'); return s ? (parseJSON(s) || []) : []; }
  function galleryOf(el) { var s = el.querySelector('[data-bundle-gallery]'); return s ? (parseJSON(s) || []) : []; }
  function currentMainId(root) {
    var form = document.querySelector('form[action*="/cart/add"]');
    if (form) { var idEl = form.querySelector('[name="id"]'); if (idEl && idEl.value) return String(idEl.value); }
    return String(root.getAttribute('data-main-variant-id') || '');
  }
  function findVariant(list, id) { id = String(id); for (var i = 0; i < list.length; i++) { if (String(list[i].id) === id) return list[i]; } return null; }
  function optionVals(v) { return (v && v.options ? v.options.map(String) : []); }
  function isColorOption(name) { return /צבע|color|ציפוי/i.test(name || ''); }
  function colorFor(val) {
    val = (val || '').toString();
    if (/זהב|gold/i.test(val) && !/רוז|rose|לבן|white/i.test(val)) return 'linear-gradient(135deg,#f6dc94,#c8a24a)';
    if (/לבן|white/i.test(val)) return 'linear-gradient(135deg,#f4f4f4,#cfcfcf)';
    if (/רוז|rose/i.test(val)) return 'linear-gradient(135deg,#f3cfc0,#dfa892)';
    if (/כסף|silver/i.test(val)) return 'linear-gradient(135deg,#eaeaea,#b9b9b9)';
    if (/שחור|black/i.test(val)) return '#2b2b2b';
    return '#ddd';
  }
  // Shortens an option NAME (not its value) for the compact variant-label line under each
  // bundle card, so a long option name (e.g. "מידת הטבעת (אמריקאית)") doesn't force the
  // label to wrap onto a second line. Written to be generic/organic on purpose (2026-07-24
  // feedback: "צריך שזה יהיה אורגני ולא כתוב באופן קשיח כי לא לכל מוצרי העוגן יהיה מידה") --
  // it pattern-matches the option NAME rather than hardcoding one product's exact option
  // text, so it kicks in automatically for ANY product whose option happens to match, and
  // simply does nothing (returns the name unchanged) for products without such an option:
  //   1. Strips any parenthetical clarification, e.g. "(אמריקאית)", from every option name.
  //   2. Any option name that (after that stripping) starts with the Hebrew root מידה/מידת
  //      -- covers מידת טבעת, מידת צמיד, מידת שרשרת, etc. on any product -- collapses to
  //      just the short word "מידה".
  function shortOptionName(name) {
    name = (name || '').replace(/\s*\([^)]*\)\s*/g, '').trim();
    if (/^מיד[הת]/.test(name)) return 'מידה';
    return name;
  }
  // Builds a label like "ציפוי זהב: לבן · מידה: 6" from a variant + its product's option
  // names. Shared by both the companion cards (names come from that product's own
  // data-bundle-optionnames island) and the main/anchor card (names come from
  // data-bundle-main-optionnames) -- previously this only existed as variantLabelFull(item,
  // variant), which read the names straight off a companion <label> element and so couldn't
  // be reused for the main card, which has no such element. Renamed/generalized 2026-07-24.
  function variantLabel(names, variant) {
    if (!variant) return '';
    var t = variant.title || ''; if (!t || t === 'Default Title') return '';
    var opts = variant.options || [], parts = [];
    for (var i = 0; i < opts.length; i++) { var nm = shortOptionName(names[i]); parts.push(nm ? (nm + ': ' + opts[i]) : opts[i]); }
    return parts.join(' · ');
  }
  function pickMatch(list, mainVals) {
    var best = null, bestScore = -1, firstAvail = null;
    for (var i = 0; i < list.length; i++) {
      var v = list[i];
      if (v.available === false) continue;
      if (!firstAvail) firstAvail = v;
      var score = 0, vo = optionVals(v);
      for (var j = 0; j < vo.length; j++) { if (mainVals.indexOf(vo[j]) !== -1) score++; }
      if (score > bestScore) { bestScore = score; best = v; }
    }
    return best || firstAvail || list[0] || null;
  }
  function chosenVariant(item, mainVals) {
    var list = variantsOf(item);
    if (item.getAttribute('data-manual') === '1') {
      var id = item.querySelector('[data-bundle-add]').getAttribute('data-variant-id');
      return findVariant(list, id) || pickMatch(list, mainVals);
    }
    return pickMatch(list, mainVals);
  }
  function applyItem(item, variant, percent) {
    var chk = item.querySelector('[data-bundle-add]');
    if (variant) { chk.setAttribute('data-variant-id', variant.id); chk.setAttribute('data-price', variant.price); }
    var price = variant ? variant.price : (parseInt(chk.getAttribute('data-price'), 10) || 0);
    var oldEl = item.querySelector('.pg__bundle__price--old'); if (oldEl) oldEl.textContent = money(price);
    var newEl = item.querySelector('[data-new-price]'); if (newEl) newEl.textContent = money(Math.round(price * (1 - percent / 100)));
    var lbl = item.querySelector('[data-bundle-variant-label]'); if (lbl) lbl.textContent = variantLabel(optionNamesOf(item), variant);
    return price;
  }
  function recalc(root) {
    var percent = parseFloat(root.getAttribute('data-bundle-percent')) || 0;
    var mainList = mainVariantsOf(root);
    var mainVar = findVariant(mainList, currentMainId(root)) || mainList[0];
    var mainPrice = mainVar ? mainVar.price : (parseInt(root.getAttribute('data-main-price'), 10) || 0);
    var mainVals = optionVals(mainVar);
    // Keep the anchor/main card's own variant line in sync with whatever the customer has
    // selected on the main add-to-cart form above -- this re-runs every time recalc() does,
    // including the existing 500ms polling loop in init() that already detects main-variant
    // changes, so it updates live with no extra wiring needed.
    var mainLbl = root.querySelector('[data-bundle-main-variant-label]');
    if (mainLbl) mainLbl.textContent = variantLabel(mainOptionNamesOf(root), mainVar);
    var selSum = 0;
    Array.prototype.forEach.call(root.querySelectorAll('.pg__bundle__item--add'), function (item) {
      var chk = item.querySelector('[data-bundle-add]');
      var variant = chosenVariant(item, mainVals);
      var price = applyItem(item, variant, percent);
      if (chk.checked) { selSum += price; item.classList.add('is-selected'); }
      else item.classList.remove('is-selected');
    });
    var discount = Math.round(selSum * percent / 100);
    var was = mainPrice + selSum;
    var total = was - discount;
    var mp = root.querySelector('[data-bundle-main-price]'); if (mp) mp.textContent = money(mainPrice);
    var t = root.querySelector('[data-bundle-total]'); if (t) t.textContent = money(total);
    var w = root.querySelector('[data-bundle-was]'); if (w) w.textContent = money(was);
    var s = root.querySelector('[data-bundle-savings]'); if (s) s.textContent = money(discount);
    var savingsWrap = root.querySelector('.pg__bundle__savings'); if (savingsWrap) savingsWrap.style.display = discount > 0 ? '' : 'none';
    var wasWrap = root.querySelector('.pg__bundle__total-was'); if (wasWrap) wasWrap.style.display = discount > 0 ? '' : 'none';
  }
  function openGallery(urls) {
    if (!urls || !urls.length) return;
    var lb = document.createElement('div'); lb.className = 'pg__bundle-lightbox';
    var close = document.createElement('button'); close.className = 'pg__bundle-lightbox__close'; close.innerHTML = '×'; close.setAttribute('aria-label', 'סגור');
    var track = document.createElement('div'); track.className = 'pg__bundle-lightbox__track';
    urls.forEach(function (u) { var im = document.createElement('img'); im.src = u; im.loading = 'lazy'; track.appendChild(im); });
    lb.appendChild(close); lb.appendChild(track);
    function remove() { lb.remove(); document.removeEventListener('keydown', onKey); }
    function onKey(e) { if (e.key === 'Escape') remove(); }
    close.addEventListener('click', remove);
    lb.addEventListener('click', function (e) { if (e.target === lb) remove(); });
    document.addEventListener('keydown', onKey);
    document.body.appendChild(lb);
  }
  function openEditor(item, root) {
    var list = variantsOf(item), names = optionNamesOf(item);
    var chk = item.querySelector('[data-bundle-add]');
    var cur = findVariant(list, chk.getAttribute('data-variant-id')) || list[0];
    var selected = cur ? cur.options.slice() : [];
    var overlay = document.createElement('div'); overlay.className = 'pg__bundle-editbox';
    var panel = document.createElement('div'); panel.className = 'pg__bundle-editbox__panel';
    var title = document.createElement('div'); title.className = 'pg__bundle-editbox__title';
    var nameEl = item.querySelector('.pg__bundle__name');
    title.textContent = nameEl ? nameEl.textContent.trim() : 'עריכת וריאציה';
    panel.appendChild(title);
    names.forEach(function (nm, idx) {
      var row = document.createElement('div'); row.className = 'pg__bundle-editbox__row';
      var lab = document.createElement('label'); lab.className = 'pg__bundle-editbox__label'; lab.textContent = nm;
      var color = isColorOption(nm), nameSpan = null;
      if (color) { nameSpan = document.createElement('span'); nameSpan.className = 'pg__bundle-editbox__selname'; nameSpan.textContent = selected[idx] ? (' – ' + selected[idx]) : ''; lab.appendChild(nameSpan); }
      var opts = document.createElement('div'); opts.className = 'pg__bundle-editbox__opts';
      var vals = [];
      list.forEach(function (v) { if (vals.indexOf(v.options[idx]) === -1) vals.push(v.options[idx]); });
      vals.forEach(function (val) {
        var btn = document.createElement('button'); btn.type = 'button';
        if (color) { btn.className = 'pg__bundle-editbox__swatch'; btn.style.background = colorFor(val); btn.title = val; }
        else { btn.className = 'pg__bundle-editbox__opt'; btn.textContent = val; }
        if (selected[idx] === val) btn.classList.add('is-active');
        btn.addEventListener('click', function () {
          selected[idx] = val;
          Array.prototype.forEach.call(opts.children, function (c) { c.classList.remove('is-active'); });
          btn.classList.add('is-active');
          if (nameSpan) nameSpan.textContent = ' – ' + val;
        });
        opts.appendChild(btn);
      });
      row.appendChild(lab); row.appendChild(opts); panel.appendChild(row);
    });
    var actions = document.createElement('div'); actions.className = 'pg__bundle-editbox__actions';
    var ok = document.createElement('button'); ok.className = 'pg__bundle-editbox__btn pg__bundle-editbox__btn--ok'; ok.textContent = 'שמור';
    var cancel = document.createElement('button'); cancel.className = 'pg__bundle-editbox__btn pg__bundle-editbox__btn--cancel'; cancel.textContent = 'ביטול';
    actions.appendChild(ok); actions.appendChild(cancel); panel.appendChild(actions);
    overlay.appendChild(panel); document.body.appendChild(overlay);
    function close() { overlay.remove(); }
    cancel.addEventListener('click', close);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    ok.addEventListener('click', function () {
      var match = null;
      list.forEach(function (v) { if (v.options.slice(0, selected.length).join('|') === selected.join('|')) match = v; });
      if (match) { item.setAttribute('data-manual', '1'); chk.setAttribute('data-variant-id', match.id); chk.setAttribute('data-price', match.price); recalc(root); }
      close();
    });
  }
  function addBundle(root, btn) {
    var percent = parseFloat(root.getAttribute('data-bundle-percent')) || 0;
    var bundleId = 'b' + Date.now() + Math.floor(Math.random() * 1000);
    var items = [{ id: parseInt(currentMainId(root), 10), quantity: 1, properties: { _bundle_id: bundleId, _bundle_role: 'main', _bundle_discount: percent + '%' } }];
    Array.prototype.forEach.call(root.querySelectorAll('[data-bundle-add]'), function (chk) {
      if (chk.checked) { items.push({ id: parseInt(chk.getAttribute('data-variant-id'), 10), quantity: 1, properties: { _bundle_id: bundleId, _bundle_role: 'addon', _bundle_discount: percent + '%' } }); }
    });
    btn.disabled = true; btn.classList.add('is-loading');
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json(); })
      .then(function () { window.location.href = '/cart'; })
      .catch(function () { btn.disabled = false; btn.classList.remove('is-loading'); alert('אירעה שגיאה בהוספת הסט לעגלה'); });
  }
  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-pg-bundle]'), function (root) {
      recalc(root);
      root.addEventListener('change', function (e) { if (e.target && e.target.matches('[data-bundle-add]')) recalc(root); });
      root.addEventListener('click', function (e) {
        var eye = e.target.closest('[data-bundle-eye]');
        if (eye) { e.preventDefault(); e.stopPropagation(); openGallery(galleryOf(eye.closest('.pg__bundle__item'))); return; }
        var ed = e.target.closest('[data-bundle-edit]');
        if (ed) { e.preventDefault(); e.stopPropagation(); openEditor(ed.closest('.pg__bundle__item'), root); return; }
      });
      var btn = root.querySelector('[data-bundle-add-btn]'); if (btn) btn.addEventListener('click', function () { addBundle(root, btn); });
      var lastId = currentMainId(root);
      setInterval(function () { var now = currentMainId(root); if (now !== lastId) { lastId = now; recalc(root); } }, 500);
    });
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();
